export const TRIAL_MODAL_PATHS = Object.freeze({
  DETAILS: "/details",
  LOADING: "/loading",
  SUCCESS: "/success",
  ERROR: "/error",
  BLOCKED_DOWNGRADE_SCHEDULED: "/blocked_downgrade_scheduled",
});

export const TRIAL_MODAL_STATES = {
  DETAILS: "details" as const,
  LOADING: "loading" as const,
  SUCCESS: "success" as const,
  ERROR: "error" as const,
  BLOCKED_DOWNGRADE_SCHEDULED: "blocked_downgrade_scheduled" as const,
};

export type TrialModalState =
  (typeof TRIAL_MODAL_STATES)[keyof typeof TRIAL_MODAL_STATES];
